import { DefaultUrlSerializer } from '@angular/router';

export namespace SerializerUtil {
    export function serialize(_url: URL) {
        const _se = new DefaultUrlSerializer();
        const _parsedUrl = _se.parse(_url.href.replace(_url?.origin, ''));
        const _serializedUrl = _se.serialize(_parsedUrl);
        return _serializedUrl;
    }
}
